import PackageIcon from "@redotech/redo-icons/package.svg";
import { ComponentType, SVGProps } from "react";
import { WalkthroughDefinition } from "./walkthrough-types";

export interface WalkthroughRegistryEntry {
  id: string;
  name: string;
  Icon?: ComponentType<SVGProps<SVGSVGElement>>;
  loader: () => Promise<{ definition: WalkthroughDefinition }>;
}

export const WALKTHROUGH_REGISTRY: WalkthroughRegistryEntry[] = [
  {
    id: "returns",
    name: "Returns",
    Icon: PackageIcon,
    loader: () => import("./definitions/returns"),
  },
];
